//导航栏
export const navigationList = [
    "首页", "服务", "场网", "应用", "成果", "新闻",
]

//FirstPage————统计
export const statisticsDatas = [
    {
        num: "23",
        type: "颗",
        name: "卫星",
        icon: "images/tempImgs/走马灯/统计/1.png"
    },
    {
        num: "54",
        type: "类",
        name: "产品",
        icon: "images/tempImgs/走马灯/统计/2.png"
    },
    {
        num: "1",
        type: "个",
        name: "工具",
        icon: "images/tempImgs/走马灯/统计/3.png"
    },
    {
        num: "957.57",
        type: "TB",
        name: "数据",
        icon: "images/tempImgs/走马灯/统计/4.png"
    },
    {
        num: "921.50",
        type: "TB",
        name: "服务卫星数据",
        icon: "images/tempImgs/走马灯/统计/5.png"
    },
]

//ServicePage————服务列表
export const servicePageList = [
    {
        title: "共性产品检验与评价服务",
        introduce: "共性产品检验与服务分系统针对不同卫星的空间分辨率与谱段设置等特征，对卫星共性产品质量进行真实性检验与服务，实现卫星几何、辐射、陆表、植被、大气、水体等各类共性产品的真实性检验。",
        img: "images/HomePage/ServicePage/img2.png",
    },
    {
        title: "真值数据采集与处理服务",
        introduce: "光学真实性检验站网地面实测数据。包括特征点几何位置、特征点高程、地表反射率、气溶胶光学厚度、水汽含量、土壤含水量、土壤温度、叶面积指数、植被指数、水体反射率、水体悬浮物浓度等产品的地面实测数据。",
        img: "images/HomePage/ServicePage/img1.png",
    },
    {
        title: "技术测评与产品定制服务",
        introduce: "立足已有国产卫星数据处理共性技术基础，着眼为未来共性技术发展和应用目标，为用户提供面向遥感应用全过程的稳定、可信、可追溯的数据处理共性技术工具集、技术检验评价工具集和在线技术检验评价实验测试环境。",
        img: "images/HomePage/ServicePage/img3.png",
    },
    {
        title: "资源共享与在线培训服务",
        introduce: "为应用系统建设和各级用户提供卫星数据、场站网实验数据、处理工具、模块、软件系统等资源集成、检验与共享、下载服务，并提供在线定制、共性技术培训、APP应用等功能，实现以多种服务模式向多层次用户提供多样式服务。",
        img: "images/HomePage/ServicePage/img4.png",
    },
]

//StationNet————系统列表
export const stationNetSystemList = [
    {
        title: "天上卫星系统",
        introduce: "面向空基“十二五”、“十三五”阶段的12型24颗陆地观测卫星，收集海量原始数据",
        img: "images/HomePage/StationNet/icon2.png",
    },
    {
        title: "真实性检验场网系统",
        introduce: "真实性检验场网系统由以下部分组成：光学微波卫星真实性检验站网、电磁卫星真实性检验站网、综合试验场、基准和综合实验室，形成多谱段、多手段、场站结合、室内外一体化的地面真值采集系统。",
        img: "images/HomePage/StationNet/icon2.png",
    },
    {
        title: "共性技术服务系统",
        introduce: "立足已有国产卫星数据处理共性技术基础，着眼为未来共性技术发展和应用目标，为用户提供面向遥感应用全过程的稳定、可信、可追溯的数据处理共性技术工具集、技术检验评价工具集和在线技术检验评价实验测试环境。",
        img: "images/HomePage/StationNet/icon3.png",
    },
]

//StationNet————走马灯列表
export const stationNetCarouselList = [
    {
        num: 6,
        title: "综合实验场",
        introduce: "由东北、华北、华中、华南、西北、西南六个综合实验场构成，主要开展星-空-地同步大型综合实验，为空基卫星的综合性能评价提供基础数据。",
        img: "images/HomePage/StationNet/img1.png",
    },
    {
        num: 48,
        title: "光学微波卫星真实性检验站网",
        introduce: "实现针对不同的产品，依托现有行业、科研机构现有的场站网资源，在全国范围内选择符合自然条件和空间分布需求的，新增部分地基测量设备，实现高频次、自动化的测量数据；并将该测量数据经过预处理后传输至共性应用技术支撑服务系统。",
        img: "images/HomePage/StationNet/img2.png",
    },
    {
        num: 6,
        title: "电磁卫星比测校验场",
        introduce: "电磁卫星真实性检验站网由建设在宁夏和甘肃的5个电磁真实性检验站（电磁观测平台）和1个电离层垂测站（电离层观测平台）组成，构建覆盖电磁卫星观测频段的电场、磁场观测系统，进行连续的地面观测，获取地面电磁观测数据。 5个电磁真实性检验站分布在宁夏高沙窝台站、宁夏太阳山-红寺堡台站、宁夏甘盐池台站、甘肃平凉台站和甘肃坪城台站。",
        img: "images/HomePage/StationNet/img3.png",
    },
    {
        num: 1,
        title: "基准与综合实验室",
        introduce: "在仪器标定环境建设等方面进行平台搭建。形成对不同测量仪器的几何、辐射、光谱等性能标定能力。为野外场站设备的快速系统标定提供支撑。",
        img: "images/HomePage/StationNet/img4.png",
    },
]

//AppScene————应用场景列表
export const appSceneList = [
    {
        title: '台风灾害监测',
        img: "images/HomePage/AppScene/1.png",
    },
    {
        title: '大气质量监测',
        img: "images/HomePage/AppScene/2.png",
    },
    {
        title: '地震灾害检测',
        img: "images/HomePage/AppScene/3.png",
    },
    {
        title: '海岸带监测',
        img: "images/HomePage/AppScene/4.png",
    },
    {
        title: '海啸灾害监测',
        img: "images/HomePage/AppScene/5.png",
    },
    {
        title: '海洋污染监测',
        img: "images/HomePage/AppScene/6.png",
    },
    {
        title: '植被状况监测',
        img: "images/HomePage/AppScene/7.png",
    },
    {
        title: '滑坡泥石流监测',
        img: "images/HomePage/AppScene/8.png",
    },
    {
        title: '粮食生产监测',
        img: "images/HomePage/AppScene/9.png",
    },
    {
        title: '气候变化关键要素监测',
        img: "images/HomePage/AppScene/10.png",
    },
    {
        title: '森林火灾监测',
        img: "images/HomePage/AppScene/11.png",
    },
    {
        title: '沙漠化监测',
        img: "images/HomePage/AppScene/12.png",
    },
    {
        title: '生态环境灾害监测',
        img: "images/HomePage/AppScene/13.png",
    },
    {
        title: '生物多样性监测',
        img: "images/HomePage/AppScene/14.png",
    },
    {
        title: '湿地监测',
        img: "images/HomePage/AppScene/15.png",
    },
]

//AchievementDisplay————应用场景列表
export const achievementDisplayList = [
    {
        title: '高分灾害预警、监测与评估信息服务示范系统应用',
        img: "images/HomePage/AchievementDisplay/img1.png",
    },
    {
        title: '高分应用系统技术、共性关键技术介绍',
        img: "images/HomePage/AchievementDisplay/img2.png",
    },
    {
        title: '高分灾害预警、监测与评估信息服务示范系统应用',
        img: "images/HomePage/AchievementDisplay/img1.png",
    },
    {
        title: '高分灾害预警、监测与评估信息服务示范系统应用',
        img: "images/HomePage/AchievementDisplay/img1.png",
    },
]

//NewsRecommend————新闻推荐列表
export const NewsRecommendList = [
    {
        title: "新闻标题展示数字保持一行",
        introduce: "美国国会众议院26日表决通过一项由民主党人提出的草案，支持首都华盛顿哥伦比亚特区成为美国第51个州。美国总统特朗普上月接受美国媒体采访时说，他反对华盛顿哥伦比亚特区成为州，不会让民主党人在国会中拥有更多席位。",
        img: "images/HomePage/NewsRecommend/1.jpeg",
        time: "2022-02-21"
    },
    {
        title: "新闻标题展示数字保持一行",
        introduce: "美国国会众议院26日表决通过一项由民主党人提出的草案，支持首都华盛顿哥伦比亚特区成为美国第51个州。美国总统特朗普上月接受美国媒体采访时说，他反对华盛顿哥伦比亚特区成为州，不会让民主党人在国会中拥有更多席位。",
        img: "images/HomePage/NewsRecommend/2.jpg",
        time: "2022-02-21"
    },
    {
        title: "新闻标题展示数字保持一行",
        introduce: "美国国会众议院26日表决通过一项由民主党人提出的草案，支持首都华盛顿哥伦比亚特区成为美国第51个州。美国总统特朗普上月接受美国媒体采访时说，他反对华盛顿哥伦比亚特区成为州，不会让民主党人在国会中拥有更多席位。",
        img: "images/HomePage/NewsRecommend/3.jpeg",
        time: "2022-02-21"
    },
    {
        title: "新闻标题展示数字保持一行",
        introduce: "美国国会众议院26日表决通过一项由民主党人提出的草案，支持首都华盛顿哥伦比亚特区成为美国第51个州。美国总统特朗普上月接受美国媒体采访时说，他反对华盛顿哥伦比亚特区成为州，不会让民主党人在国会中拥有更多席位。",
        img: "images/HomePage/NewsRecommend/4.jpg",
        time: "2022-02-21"
    },
]